<template>
  <div class="follow" v-if="follow">
    <div class="head pos-f t0 l0 r0">
      <img src="../../assets/images/follow.jpg" />
      <div class="btn" @click="followFn"></div>
    </div>
    <van-overlay :show="show" z-index="2002">
      <div class="wrapper">
        <div class="block">
          <img src="../../assets/images/follow.png" />
          <van-icon name="close" @click="show = false" />
        </div>
      </div>
    </van-overlay>
    <van-popup
      v-if="isWx"
      v-model="followShow"
      style="border-radius: 0.12rem 0.12rem 0 0"
      round
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '40%' }"
    >
      <div class="followShow">
        <div class="f15 fb flex-ac title">
          <img src="/static/images/logo.png" />
          创客村&nbsp;&nbsp;温馨提示
        </div>
        <div class="content">
          <div class="f17 flex-js-ac">
            <p>打开创客云商小程序商城</p>
            <img src="/static/images/yes.png" />
          </div>

          <div class="f17 flex-js-ac">
            <p>便捷查询福利和订单信息</p>
            <img src="/static/images/yes.png" />
          </div>
        </div>
        <div class="follow-btn">
          <van-button type="primary" block>前往小程序商城</van-button>
          <div :path="path" class="slide_cl_xcx" v-if="isWx" :username="'gh_5d4bb8e18b8b'"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  setCookie,
  browHistory,
  isWeixin,
  exclusiveidFn,
  pointParams
} from '../../assets/common/js/config'
import Vue from 'vue'
import { Overlay } from 'vant'
Vue.use(Overlay)
export default {
  name: 'follow',
  props: {
    path: {
      type: String,
      default: '/pages/index/main.html?exclusiveid=' + exclusiveidFn() + pointParams('&')
    },
    pathType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      follow: false,
      isWx: isWeixin() ? 1 : 0,
      followShow: false
    }
  },
  mounted() {
    this.getdata()
  },
  methods: {
    getdata() {
      var url = this.$ajax.getSubscribe_URL
      var that = this
      if (!isWeixin()) {
        that.$emit('follow', that.follow)
        return
      }
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          // setCookie('ckc4_subscribe', res.data.subscribe, 2 * 60 * 60 * 1000)
          if (res.data.subscribe == 2) {
            // if ((that.pathType == 'homePage' || (that.$route.query.shareOpenid && that.$route.query.shareOpenid != '0')) && that.$route.query.pt != 'xcx') that.followShow = true
            that.follow = true
            that.$emit('follow', that.follow)
            // that.goXcxCreateBtnFn()
          } else {
            that.followShow = false
            that.follow = false
            that.$emit('follow', that.follow)
          }
        }
      })
    },
    goXcxCreateBtnFn: function () {
      this.$nextTick(function () {
        var slideClXcx = document.getElementsByClassName('slide_cl_xcx')
        for (var i = 0; i < slideClXcx.length; i++) {
          if (
            slideClXcx[i].attributes.path.value &&
            slideClXcx[i].innerHTML.indexOf('wx-open-launch-weapp') < 0
          ) {
            var script = document.createElement('script')
            script.type = 'text/wxtag-template'
            script.text = `<div style="width: ${slideClXcx[i].clientWidth}px; height: ${slideClXcx[i].clientHeight}px" class="box"></div>`
            slideClXcx[i].innerHTML = `<wx-open-launch-weapp
                      style="display:block; width:100%;height:100%;"
                      id="launch-btn${i}"
                      username="gh_5d4bb8e18b8b"
                      path="${slideClXcx[i].attributes.path.value}"
                    >${script.outerHTML}</wx-open-launch-weapp>`
            var btn = document.getElementById(`launch-btn${i}`)
            btn.addEventListener('launch', function (e) {
              browHistory({
                page: 'index', // 首页 index  账单yearbill
                toappid: 6,
                topage: 'livelist' // 首页 index  账单yearbill 直播列表 livelist 直播间 live
              })
            })
          }
        }
      })
    },
    followFn() {
      var that = this
      setCookie('ckc4_subscribe', '')
      setTimeout(function () {
        that.show = true
      }, 800)
    }
  }
}
</script>

<style scoped lang="scss">
.follow {
  z-index: 2002;
  position: sticky;
  top: 0px;
  .head {
    position: relative;
    .btn {
      position: absolute;
      right: 0;
      top: 0;
      height: 0.5rem;
      width: 32%;
    }
  }
  img {
    width: 100%;
    display: block;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 2.6rem;
    background-color: #fff;
    position: relative;
    border-radius: 0.06rem;
    .van-icon-close {
      position: absolute;
      bottom: -0.36rem;
      left: 50%;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      -moz-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      -o-transform: translateX(-50%);
      color: #fff;
      font-size: 0.26rem;
    }
  }
  .followShow {
    padding: 0.15rem 0.24rem 0.1rem;
    height: 100%;
    position: relative;
    .title {
      color: #000000;
      padding-bottom: 0.21rem;
      position: relative;
      &:after {
        position: absolute;
        content: '';
        display: block;
        height: 0.01rem;
        left: -0.24rem;
        right: -0.24rem;
        bottom: 0;
        opacity: 0.1;
        background: #000000;
      }
      img {
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 50%;
        margin-right: 0.1rem;
      }
    }
    .content {
      color: #000000;
      div {
        padding: 0.15rem 0 0.17rem;
        position: relative;
        &:after {
          position: absolute;
          content: '';
          display: block;
          height: 0.01rem;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0.1;
          background: #000000;
        }
      }
      img {
        width: 0.24rem;
        height: 0.24rem;
      }
    }
    .follow-btn {
      position: absolute;
      margin-top: 0.1rem;
      left: 0.97rem;
      right: 0.94rem;
    }
  }

  .slide_cl_xcx {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/follow.vue